import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'

import { UtilCommonModule } from 'common/util'
import { LocaleModule } from 'common/locale'
import { MediaTagsModule } from 'media.badges'
import { MediaCustomFieldsModule } from 'media.customFields'

import { UploaderPanelComponent } from './components/uploaderPanel.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LocaleModule.forChild(),
    NgbNavModule,
    UtilCommonModule,
    MediaCustomFieldsModule,
    MediaTagsModule,
    UploaderPanelComponent,
  ],
  exports: [
    UploaderPanelComponent,
  ],
})
export class UploaderModule { }

export { UploaderService, GenericFileReader } from './services/uploader.service'
export { UploaderPanelComponent }
